import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const TooltipTitle = superstyled({
  tag: Box,
  name: 'TooltipTitle',
  slot: 'TooltipTitle',
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.fixed.grey['800'],
    borderRadius: '0.75rem',
    boxShadow: theme.shadows[5],
    marginTop: '0.25rem !important',
    padding: '1rem',
  }),
});
